var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cancel-subscription"},[_c('div',{staticClass:"cancel-subscription__wrap"},[_c('div',{staticClass:"cancel-subscription__content"},[_vm._v("\n\t\t\t"+_vm._s((
					_vm.getDays() ? 
					_vm.$t("subscribeTitle2Top") : 
					_vm.$t("subscribeTitle5Top")
				)
				.replace(':amount', _vm.currentPlan.tariff.data.price)
				.replace(':next', _vm.nextDate())
				.replace(':date', _vm.endDate())
				.replace(':end', _vm.endDate()))+"\n\t\t\t"),_c('br'),_vm._v("\n\t\t\t"+_vm._s((
					_vm.getDays() ? 
					_vm.$t("subscribeTitle3Center") : 
					_vm.$t("subscribeTitle6Center")
				)
				.replace(':amount', _vm.currentPlan.tariff.data.price)
				.replace(':next', _vm.nextDate())
				.replace(':date', _vm.endDate())
				.replace(':end', _vm.endDate()))+"\n\t\t\t"),_c('br'),_vm._v("\n\t\t\t"+_vm._s(_vm.getDays() ? 
				_vm.$t("subscribeTitle4Bottom") : 
				_vm.$t("subscribeTitle7Bottom"))+"\n\t\t\t\n\t\t\t"),_c('div',{staticClass:"cancel-subscription__actions"},[_c('div',{staticClass:"cancel-subscription__btn",staticStyle:{"margin-right":"20px"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.changeShowPopup(false)}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t("subscribeNo"))+"\n\t\t\t\t\t")])]),_c('div',{staticClass:"cancel-subscription__btn"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.updatePlan(_vm.currentPlan)}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t("subscribeYes2"))+"\n\t\t\t\t\t")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }